import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { startSetPaymentsData } from '../../actions/finances';
import { startSetSlavePaymentsData } from '../../actions/slaves';
import Card from '../Card/Card';
import Pagination from '../Pagination/Pagination';
import PaymentDataList from './PaymentDataList';
import { getSlaveId } from '../Statistics/statisticsHelpers';

class PaymentsData extends Component {
  static propTypes = {};
  static defaultProps = {
    paymentsData: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      limit: 20,
      page: 0,
    };

    this.$el = React.createRef();
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    const { limit, page } = this.state;
    const { isMember, startSetSlavePaymentsData, startSetPaymentsData } = this.props;
    if (!isMember) {
      startSetPaymentsData({ limit, page });
    } else {
      startSetSlavePaymentsData({ limit, page, id: getSlaveId() });
    }
  };

  changePage = page => {
    this.setState(
      () => ({ page }),
      () => {
        this.getData();
      },
    );
  };

  getPropsPaymentsData = () => {
    const { isMember, paymentsData: webmasterPaymentsData, slaves: { paymentsData } } = this.props;
    let paymentData = webmasterPaymentsData.items;
    let count = webmasterPaymentsData.count;
    if (isMember) {
      paymentData = paymentsData.items;
      count = paymentsData.count;
    }
    return {
      paymentsData: paymentData, count
    };
  }

  render() {
    const { limit, page } = this.state;
    const { paymentsData, count } = this.getPropsPaymentsData();
    const pageCount = Math.ceil(count / limit);
    return (
      <div className="payments-list-block" ref={this.$el}>
        <Card.Body className="no-padding">
          {paymentsData.length > 0 ? (
            <PaymentDataList operations={paymentsData} />
          ) : (
              <div className="card-empty">
                <FormattedMessage id="payments.list.empty" defaultMessage="No Info" />
              </div>
            )}
        </Card.Body>

        {pageCount > 1 && (
          <Card.Footer>
            <Pagination
              activePage={page + 1}
              pageCount={pageCount}
              onPageChange={this.changePage}
              scrollToAfterPageChanged={{ ref: this.$el.current }}
            />
          </Card.Footer>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  paymentsData: state.finances.paymentsData,
  slaves: state.slaves,
});

const mapDispatchToProps = dispatch => ({
  startSetPaymentsData: params => dispatch(startSetPaymentsData(params)),
  startSetSlavePaymentsData: params => dispatch(startSetSlavePaymentsData(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentsData);
